import angular from 'angular';
import uiRouter from 'angular-ui-router';
import trafficComponent from './traffic.component';

const stateSettings = {
  name: 'app.traffic',
  state: {
    url: '/traffic',
    views: {
      '': {
        template: '<traffic></traffic>'
      }
    },
    title: {
      key: 'app.traffic.title',
      en: 'News'
    }
  }
};

/* @ngInject */
function stateConfiguration($stateProvider) {
  $stateProvider.state(stateSettings.name, stateSettings.state);
}

const module = angular
  .module('traffic', [
    uiRouter,
    'config',
    'constants',
    'apiService'
  ])
  .config(stateConfiguration)
  .component('traffic', trafficComponent);

export default module;



/** WEBPACK FOOTER **
 ** ./client/app/components/traffic/traffic.js
 **/